
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/privateAppsPanel/components/common/updateInProgressIndication/updateInProgressIndication.scss.css.virtualfile';
        module.exports = {"update-in-progress":"_update-in-progress_1nwd2_1","updateInProgress":"_update-in-progress_1nwd2_1"};